import styled from "styled-components"

export const WelcomeGreeting = styled.div`
  margin-bottom: 4rem;
  padding: 3rem 2rem 2rem;
  color: ${(p) => p.theme.colors.white};
  border-radius: 0.8rem;
  font-size: 2.8rem;
  background: ${(p) => p.theme.colors.turquoiseDark};
  position: relative;
`

export const SubGreeting = styled.div`
  font-size: 2rem;
  margin-top: 1rem;
  font-weight: bold;
`

export const GreetingDate = styled.div`
  position: absolute;
  font-size: 1.6rem;
  top: 2rem;
  right: 2rem;
`
